module.exports = __webpack_public_path__ + "img/res-bg-1.5e726765.png";